// extracted by mini-css-extract-plugin
export default {"title":"CardAndLoans_title__EiXAP"};